import React from 'react';
import './Home.css';

const Home = () => {
  return (
    <div className="home">
      <h1>REAL CAFE</h1>
      <h2>Cafe & Eatery</h2>
    </div>
  );
};

export default Home;
